import React, { Component, Fragment } from 'react';
import Amplify, { Auth, Cache, API } from 'aws-amplify';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import PropTypes from 'proptypes';
import config from '../configuration/config';
import './LoaderBtn.scss';
import './App.scss';
import Header from './lib/header/Header';
import ScrolledHeader from './lib/header/ScrolledHeader';
import Hero from './lib/hero/Hero';
import Sidebar from './lib/sidebar/Sidebar';
import Footer from './lib/footer/Footer';
import AuthWrapper from './AuthWrapper';
import SignIn from './screens/loginRegister/SignIn';
import SignUp from './screens/loginRegister/SignUp';
import ForgotPassword from './screens/loginRegister/ForgotPassword';
import VerifyAccount from './screens/loginRegister/VerifyAccount';
import Registration from './lib/registration/Registration';
import PortalHome from './screens/portalHome/PortalHome';
import Profile from './screens/UserProfile/Profile';
import TripList from './lib/triplist/TripList';
import FundRaise from './screens/fundraise/FundRaise';
import Error from './screens/Error';
import Error404 from './Error404';
import Admin from './screens/admin/Admin';
import { readableResponseMessage } from '../helpers/local_modules/ux-helpers';
import DataLayer from '../configuration/dataLayer';

Amplify.configure({
  Auth: config.cognito,
  API: {
    endpoints: [
      {
        name: 'give-api',
        endpoint: config.apiGateway.url,
      },
    ],
  },
  Storage: {
    bucket: 'give-portal',
    region: 'us-east-1',
  },
});

class App extends Component {
  state = {
    identity: {},
    hasLoggedOut: false,
    isToggled: false,
    additionalTripCost: 0,
    userProps: {},
    autoLogin: false,
    isProcessing: false,
  };

  // TODO: Refactor all of the Auth.currentSession()'s
  // & See if they are neccessary and/or
  // implement a timer object to refresh Auth

  // TODO: In chained functions, handle state changes
  // through one function call

  // TODO: Parent functions should return a promise for
  // the child functions to handle

  componentDidMount() {
    document.getElementById('app-overlay').addEventListener('click', () => {
      this.toggleSideBar();
    });
    this.props.history.listen(location => {
      //  ReactGA.set({ page: location.pathname }); // Update the user's current page
      //  ReactGA.pageview(location.pathname); // Record a pageview for the given page
    });
  }

  autoLogin = () => {
    if (this.state.userProps.emailAddress && this.state.userProps.password) {
      this.setState({
        autoLogin: true,
      });

      setTimeout(() => {
        const passwordLabel = document.getElementById('pw-label');

        if (passwordLabel !== null && passwordLabel !== undefined) {
          passwordLabel.classList.add('notEmpty');
        }

        const loginButton = document.getElementById('login-button');

        if (loginButton !== null && loginButton !== undefined) {
          loginButton.click();
        }
        this.setState({
          autoLogin: false,
        });
      }, 50);
    }
  };

  setTripState = (index, newState) => {
    const newUserState = this.state.user;
    newUserState.trips[index] = newState;
    this.setState({ user: newUserState });
  };

  getParentState = name => {
    return this.state[name];
  };

  setParentState = (name, value) => {
    if (typeof value === 'object') {
      const existingValue = this.state[name];
      value = { ...existingValue, ...value };
    }
    this.setState({
      [name]: value,
    });
  };

  setAppState = newState => {
    this.setState({
      user: {
        ...newState,
      },
    });
  };

  setRoute = () => {
    const { user } = this.state;
    let route = '/';
    const requestedRoute = this.props.history.location['pathname'];
    if (requestedRoute === '/admin' && !this.state.emulate) {
      route = '/admin';
    } else if (this.canAccessPortalHome(this.state.user)) {
      route = '/portal-home';
    } else if (user && user.trips !== undefined && !user.trips.length && user.pastTrips.length) {
      route = '/trip-selection';
    } else {
      route = '/registration';
    }
    if (route !== requestedRoute) {
      this.props.history.push(route);
      // ReactGA.event({
      //   category: "Routing",
      //   action: "User routed to " + route,
      // });
    } else {
      // Not sure we wouldn't push the route; seems backwards.
      this.props.history.push(route);
    }
    window.scrollTo({
      top: 400,
      behavior: 'smooth',
    });
  };

  hasPaidDeposit = () => {
    const {
      trips: [
        {
          payments: { tripAmount, tripBalance, deposit },
        },
      ],
    } = this.state.user;

    return tripAmount - tripBalance >= deposit;
  };

  canAccessPortalHome = user =>
    user &&
    user.approved &&
    user.trips &&
    (user.trips.length > 1 ||
      (user.trips.length === 1 && (this.hasPaidDeposit() || user.pastTrips.length)));

  postAdditionalInfo = info => {
    Auth.currentSession().then(user => {
      const options = {
        headers: {
          Authorization: user.idToken.jwtToken,
          Token: user.accessToken.jwtToken,
          'Content-Type': 'application/json',
        },
        body: JSON.parse(info),
      };
      options.body.userId = this.state.user.id;
      options.body.userName = user.idToken.payload.nickname;
      API.post('give-api', '/user/', options)
        .then(() => {
          window.localStorage.removeItem('additionalInformation');
        })
        .catch(error => {
          this.setState({
            message: readableResponseMessage(error),
          });
        });
    });
  };

  initUser = () => {
    Auth.currentSession()
      .then(auth => {
        this.setState({ identity: auth });
        let userAPI = '/user';
        if (this.state.emulate) {
          userAPI = '/user?email=' + this.state.emulate;
        } else {
          // ReactGA.set({
          //   authUserEmail: auth.idToken.payload['email'],
          // })
        }
        API.get('give-api', `${userAPI}`, {
          headers: {
            Authorization: auth.idToken.jwtToken,
            Token: auth.accessToken.jwtToken,
          },
        })
          .then(response => {
            if (response.name) {
              this.setState({
                user: response,
              });
              const data = window.localStorage.getItem('additionalInformation');
              if (response.trips && response.trips.length && data && Object.keys(data).length) {
                this.postAdditionalInfo(data);
              }
            }
            this.setRoute();
          })
          .catch(error => {
            if (error.toString() === 'Error: Network Error') {
              this.props.history.push('/error');
            } else {
              const userAttributes = this.state.identity['idToken']['payload'];
              this.setState({
                user: {},
                userProps: {
                  firstName: userAttributes.given_name,
                  lastName: userAttributes.family_name,
                  phoneNumber: userAttributes.phone_number
                    ? userAttributes.phone_number.replace('+', '')
                    : userAttributes['custom:provided_phone']
                    ? userAttributes['custom:provided_phone'].replace('+', '')
                    : '',
                  emailAddress: userAttributes.email,
                },
              });
              this.setRoute();
            }
          });
      })
      .catch(() => {
        this.props.history.push('/error');
      });
  };

  handleRouting = () => {
    this.initUser();
  };

  resetSession = () => {
    this.setState({ emulate: undefined });
    this.props.history.push('/admin');
  };

  handleFetchingUser = () => {
    if (!this.state.user) {
      this.initUser();
    }
  };

  toggleSideBar = () => {
    const overlay = document.getElementById('app-overlay');

    if (overlay.classList.contains('enabled')) {
      overlay.classList.remove('enabled');
    } else {
      overlay.classList.add('enabled');
    }
    this.setState(({ isToggled }) => ({ isToggled: !isToggled }));
  };

  handleLogin = token => {
    this.setState({
      hasLoggedOut: false,
    });
    window.localStorage.setItem('sessionToken', token);
  };

  handleLogout = () => {
    this.setState({
      hasLoggedOut: true,
    });
    Auth.signOut()
      .then(() => {
        Cache.clear();
        window.localStorage.removeItem('sessionToken');
        this.props.history.push('/');
        this.setState({
          user: null,
          userProps: {},
        });
      })
      .catch(() => {
        this.setState({
          hasLoggedOut: false,
        });
      });
  };

  updateAddOnPricing = (
    boolSubtract,
    tripIndex,
    addOnCost,
    addOnDeposit,
    currentAddOns,
    availableAddOns
  ) => {
    return new Promise(resolve => {
      if (boolSubtract) {
        addOnCost = -Math.abs(addOnCost);
        addOnDeposit = -Math.abs(addOnDeposit);
      }
      const newUserState = this.state.user;
      newUserState.trips[[tripIndex]].payments.addOnsDeposit += addOnDeposit;
      newUserState.trips[[tripIndex]].currentAddOns = currentAddOns;
      newUserState.trips[[tripIndex]].availableAddOns = availableAddOns;
      this.setState({
        user: { ...newUserState },
        additionalTripCost: parseInt(addOnCost),
        isProcessing: false,
      });
      resolve();
    });
  };

  addTripAddOn = (addOn, addOnIndex, tripIndex) => {
    return new Promise((resolve, reject) => {
      const { name, id, productId, tripId } = addOn;

      Auth.currentSession()
        .then(user => {
          const _headers = {
            Authorization: user.idToken.jwtToken,
            Token: user.accessToken.jwtToken,
            'Content-Type': 'application/json',
          };

          const options = {
            headers: _headers,
            body: {
              name,
              id,
              productId,
            },
          };

          API.post('give-api', `/user/trips/${tripId}/addons`, options)
            .then(resp => {
              const tripObject = this.state.user.trips[tripIndex];
              let _addOn = addOn;
              _addOn.tripAddOnId = resp.Data.tripAddOnId;
              tripObject.currentAddOns.push(_addOn);
              tripObject.availableAddOns.splice(addOnIndex, 1);

              DataLayer.createEcommerceEvent('add_to_cart', [
                {
                  item_id: _addOn.tripAddOnId,
                  item_name: _addOn.productName,
                  item_category: 'Add-On',
                  price: _addOn.unitPrice,
                  quantity: 1,
                },
              ]);

              this.updateAddOnPricing(
                false,
                tripIndex,
                addOn.unitPrice,
                addOn.tripAddOnDeposit,
                tripObject.currentAddOns,
                tripObject.availableAddOns
              ).then(() => {
                resolve(resp);
              });
            })
            .catch(error => {
              reject(error);
            });
        })
        .catch(error => {
          reject(error);
        });
    });
  };

  deleteTripAddOn = (tripId, tripIndex, addOnIndex, addOn) => {
    this.setState({
      isProcessing: true,
    });
    Auth.currentSession().then(user => {
      const options = {
        headers: {
          Authorization: user.idToken.jwtToken,
          Token: user.accessToken.jwtToken,
          'Content-Type': 'application/json',
        },
        body: {
          id: addOn.tripAddOnId,
          product: addOn.productName,
        },
      };
      API.del('give-api', `/user/trips/${tripId}/addons`, options)
        .then(() => {
          const tripObject = this.state.user.trips[tripIndex];
          // adds selected addOn back to availableAddOns
          tripObject.availableAddOns.push(addOn);
          // removes selected addOn from currentAddOns
          tripObject.currentAddOns.splice(addOnIndex, 1);

          DataLayer.createEcommerceEvent('remove_from_cart', [
            {
              item_id: addOn.tripAddOnId,
              item_name: addOn.productName,
              item_category: 'Add-On',
              price: addOn.unitPrice,
              quantity: 1,
            },
          ]);

          this.updateAddOnPricing(
            true,
            tripIndex,
            addOn.unitPrice,
            addOn.tripAddOnDeposit,
            tripObject.currentAddOns,
            tripObject.availableAddOns
          );
        })
        .catch(error => {
          this.setState({
            message: readableResponseMessage(error),
            isProcessing: false,
          });
        });
    });
  };

  deleteTripHandler = id => {
    const newTripsArray = this.state.user.trips.filter(trip => trip.id !== id);
    const newUserObject = { ...this.state.user, trips: [...newTripsArray] };
    const trip = this.state.user.trips.filter(trip => trip.id === id);
    DataLayer.createEcommerceEvent('remove_from_cart', [
      {
        item_id: trip.id,
        item_name: trip.name,
        item_category: 'Trip',
        quantity: 1,
      },
    ]);
    this.setState({ user: newUserObject });
    this.setRoute();
  };

  updateTripCost = (tripIndex, additionalTripCost, tripAddOnDeposit) => {
    const { tripAmount, tripBalance, addOnsDeposit } = this.state.user.trips[[tripIndex]].payments;
    const newUserState = this.state.user;
    newUserState.trips[[tripIndex]].payments.tripBalance = tripBalance + additionalTripCost;
    newUserState.trips[[tripIndex]].payments.tripAmount = tripAmount + additionalTripCost;
    newUserState.trips[[tripIndex]].payments.addOnsDeposit = addOnsDeposit + tripAddOnDeposit;
    this.setState({
      user: { ...newUserState },
      additionalTripCost: additionalTripCost, // Store the numeric value
    });
  };

  render() {
    const { pathname } = this.props.history.location;
    const { user } = this.state;

    return (
      <div>
        <Sidebar
          toggleSideBar={this.toggleSideBar}
          isToggled={this.state.isToggled}
          onLogout={this.handleLogout}
        />
        <div id="app-overlay" className="app-overlay" />
        <Header
          pathname={pathname}
          onLogout={this.handleLogout}
          toggleSideBar={this.toggleSideBar}
        />
        <ScrolledHeader
          pathname={pathname}
          onLogout={this.handleLogout}
          toggleSideBar={this.toggleSideBar}
        />
        <Hero
          title={`${
            this.canAccessPortalHome(user) ? 'WELCOME TO YOUR GIVE PROFILE' : 'YOUR GIVE PROFILE'
          }`}
        />
        {this.state.emulate ? (
          <div className="chip">
            Previewing {this.state.emulate}
            <div className="close-icon" onClick={this.resetSession}></div>
          </div>
        ) : (
          ''
        )}
        <main>
          <Switch>
            <Route
              exact
              path="/"
              render={props =>
                window.localStorage.sessionToken &&
                user &&
                user.approved &&
                user.trips &&
                (user.trips.length > 1 || (user.trips.length === 1 && this.hasPaidDeposit())) ? (
                  <Redirect to="/portal-home" />
                ) : (
                  <SignIn
                    {...props}
                    isVerified={this.state.isVerified}
                    onLogin={this.handleLogin}
                    handleRouting={this.handleRouting}
                    component={SignIn}
                    setParentState={this.setParentState}
                    userProps={this.state.userProps}
                    autoLogin={this.state.autoLogin}
                  />
                )
              }
            />
            <Route path="/fundraise/:tripName" component={FundRaise} />
            <Route
              path="/sign-up"
              render={props =>
                window.localStorage.sessionToken &&
                user &&
                user.approved &&
                user.trips &&
                user.trips.length > 1 ? (
                  <Redirect to="/portal-home" />
                ) : (
                  <SignUp
                    {...props}
                    handleRouting={this.handleRouting}
                    setParentState={this.setParentState}
                  />
                )
              }
            />
            <Route
              path="/forgot-password"
              history={this.props.history}
              component={ForgotPassword}
            />
            <Route
              path="/verify-account"
              render={() => (
                <VerifyAccount
                  history={this.props.history}
                  userProps={this.state.userProps}
                  setParentState={this.setParentState}
                  autoLogin={this.autoLogin}
                />
              )}
            />
            <Route
              path="/error"
              render={() => (
                <Error
                  user={user}
                  history={this.props.history}
                  handleRouting={this.handleRouting}
                />
              )}
            />
            <AuthWrapper
              history={this.props.history}
              onFetchingUser={this.handleFetchingUser}
              hasLoggedOut={this.state.hasLoggedOut}
            >
              {this.state.user ? (
                <Fragment>
                  <Route
                    path="/admin"
                    render={() =>
                      this.state.identity.accessToken.payload['cognito:groups'] &&
                      this.state.identity.accessToken.payload['cognito:groups'][0] ===
                        'GivePortalAdmins' ? (
                        <Admin
                          handleRouting={this.handleRouting}
                          setParentState={this.setParentState}
                          history={this.props.history}
                        />
                      ) : (
                        <Route component={Error404} />
                      )
                    }
                  />
                  <Route
                    path="/registration"
                    render={() => (
                      <Registration
                        user={user}
                        hasPaidDeposit={
                          user.trips && user.trips.length ? this.hasPaidDeposit() : false
                        }
                        onLogout={this.handleLogout}
                        userProps={this.state.userProps}
                        history={this.props.history}
                        handleRouting={this.handleRouting}
                        getParentState={this.getParentState}
                        setParentState={this.setParentState}
                        updateTripCost={this.updateTripCost}
                        addTripAddOn={this.addTripAddOn}
                        deleteTripAddOn={this.deleteTripAddOn}
                        setAppState={this.setAppState}
                        isProcessing={this.state.isProcessing}
                      />
                    )}
                  />
                  {user.trips !== undefined &&
                  (!user.trips.length || user.trips.length || user.pastTrips.length) ? (
                    <Fragment>
                      <Route
                        path="/trip-selection"
                        render={() => (
                          <TripList
                            user={user}
                            setAppState={this.setAppState}
                            handleRouting={this.handleRouting}
                            setParentState={this.setParentState}
                            replaceOpportunityId={
                              this.state.replaceOpportunityId ? this.state.replaceOpportunityId : ''
                            }
                          />
                        )}
                      />
                      <Route
                        path="/profile"
                        render={() => <Profile user={user} setAppState={this.setAppState} />}
                      />
                    </Fragment>
                  ) : (
                    ''
                  )}
                  {this.canAccessPortalHome(user) ? (
                    <Fragment>
                      <Route
                        path="/portal-home"
                        render={() => (
                          <PortalHome
                            user={this.state.user}
                            history={this.props.history}
                            handleRouting={this.handleRouting}
                            setParentState={this.setParentState}
                            addTripAddOn={this.addTripAddOn}
                            deleteTripAddOn={this.deleteTripAddOn}
                            deleteTripHandler={this.deleteTripHandler}
                            additionalTripCost={this.state.additionalTripCost}
                            updateTripCost={this.updateTripCost}
                            setTripState={this.setTripState}
                            setAppState={this.setAppState}
                            userProps={this.state.userProps}
                            isProcessing={this.state.isProcessing}
                          />
                        )}
                      />
                    </Fragment>
                  ) : (
                    ''
                  )}
                </Fragment>
              ) : (
                <div className="loader throbber full-page" />
              )}
            </AuthWrapper>
            <Route component={Error404} />
          </Switch>
        </main>
        <Footer onLogout={this.handleLogout} pathname={pathname} />
      </div>
    );
  }
}

App.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};

export default withRouter(App);
